import React from "react";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";

import Section from "../../components/shared-ui/Section/Section";
import Accordion from "../../components/shared-ui/Accordion/Accordion";

// @todo - change to PED versions
import PEDLayout from "./PEDLayout";
import PEDHeroHeader from "../../components/HeroHeader/PEDHeroHeader";

import "../../css/PED/PatientResources.scss";

export default function PatientResources() {
  const showPhreesiaModal = (e) => {
    e.preventDefault();
    let modal = document.querySelector("#phreesia-modal");
    document.body.classList.add("no-scroll");
    modal.classList.remove("fadeOut");
    modal.style.display = "block";
    modal.classList.add("fadeIn");
    modal.style.height = "100%";
    modal.querySelector(".exitBtn").addEventListener("click", function () {
      modal.style.display = "none";
      document.body.classList.remove("no-scroll");
    });
    modal
      .querySelector(".modal-overlay")
      .addEventListener("click", function () {
        modal.style.display = "none";
        document.body.classList.remove("no-scroll");
      });
  };
  return (
    <>
      <Helmet>
        <title>Caregiver Resources & FAQs| DOPTELET®️ and DOPTELET Sprinkle (avatrombopag)</title>
        <meta name="description" content="Access resources designed for caregivers to help navigate your child's persistent or chronic ITP, including educational materials and copay assistance enrollment." />
      </Helmet>
      <PEDLayout pageClass="ped-resources-patient-resources">
        <PEDHeroHeader
          extraClass="large-hero inner-bg home-hero"
          markup={
            <>
              <h1>CAREGIVER RESOURCES &amp; FAQS</h1>
              <p>
                Use the resources below to learn more about Doptelet and
                Doptelet Sprinkle and find support for your child’s journey with
                persistent or chronic ITP.
              </p>
            </>
          }
          maxWidth="525"
          bgImage={[
            "/images/ped/hero/patient-resources-hero-desktop.jpg",
            "/images/ped/hero/patient-resources-hero-desktop.jpg",
          ]}
          bgImageMobile={[
            "/images/ped/hero/patient-resources-hero.png",
            "/images/ped/hero/patient-resources-hero@2x.png",
          ]}
        />

        <Section sectionClass="section-padding important-downloads">
          <h2>Important downloads</h2>
          <div className="download-cards">
            <div className="download-card">
              <h3>Starting Doptelet or Doptelet Sprinkle?</h3>
              <p>
                Read more about what your child and family can experience when
                taking treatment for persistent or chronic ITP.
              </p>
              <Link
                to={{
                  pathname: "/pdf/PP-29112_Doptelet_US_Commercial_Digital-Caregiver-Brochure.pdf"
                }}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-primary download w-100 download-right"
              >
                <span>Download Brochure</span>
              </Link>
            </div>
            <div className="download-card">
              <h3>Want information about patient support programs?</h3>
              <p>
                See the options available to you, review the eligibility
                criteria, and enroll today.
              </p>
              <a
                href="/pediatric-itp/support-and-resources/caregiver-financial-assistance/"
                className="btn btn-primary w-100"
              >
                <span>Learn More</span>
              </a>
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding talking-to-doctor">
          <div className="talk-doctor">
            <div>
              <img src="/images/ped/resources/icon-talk-doctor@2x.png" alt="" />
            </div>
            <div>
              <h2>Talking to your child’s doctor soon?</h2>
              <p>
                Working with the doctor can help raise your chances of finding a
                treatment that fits your child’s needs and goals. Here are a few
                questions to consider before starting a conversation with your
                child’s doctor:
              </p>
              <ul style={{ marginBottom: "24px" }}>
                <li>
                  What is your child’s most important treatment goal and why?
                </li>
                <li>
                  Could this treatment affect your child’s eating habits,
                  including the types of food, and what time they eat?
                </li>
                <li>
                  Would your child rather take an oral dose or get an injection?
                </li>
                <li>
                  Are you interested in financial assistance or patient support
                  programs?
                </li>
              </ul>
              {/* <a href="/ped/" className="btn btn-primary download">
                <span>Download Guide</span>
              </a> */}
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding">
          <div className="got-questions">
            <h2>Got questions? Speak to a Doptelet Advisor</h2>
            <p>
              Trying to raise your child’s low platelet count can raise some
              questions. The good news is that Doptelet Advisors can help get
              you the answers you need and point you toward resources. Give them
              a call at{" "}
              <a style={{ color: "#DA1A32" }} href="tel:18333682663">
                1-833-368-2663
              </a>
              .
            </p>
          </div>
        </Section>

        <Section>
          <div className="florio">
            <div className="florio-content">
              <h2>
                Keep your child’s ITP journey on track with my florio ITP
                <sup>™</sup>
              </h2>
              <img
                className="d-block d-lg-none"
                src="/images/ped/resources/florio-logo@2x.png"
                alt=""
              />
              <p>
                my florio ITP<sup>TM</sup> is an all-in-one app designed to
                monitor all things ITP—platelet counts, bruising events,
                appointments, treatments, and more—plus, it’s free!
              </p>

              <p>
                Get started with my florio ITP<sup>TM</sup> by downloading the
                app through the Apple Store or Google Play.
              </p>
              <div className="app-store-logos">
                <a
                  href="https://apps.apple.com/no/app/florio-itp/id1610121401"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/ped/resources/app-store@2x.png" alt="" />
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=app.florio.itp.eu.mdd&pli=1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/images/ped/resources/google-play@2x.png" alt="" />
                </a>
              </div>
            </div>
            <div className="florio-image d-none d-lg-block">
              <img
                src="/images/ped/resources/florio-logo-desktop@2x.png"
                alt=""
              />
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding support-group">
          <div className="">
            <div className="support-group-header">
              <div className="">
                <h2>Join support groups for persistent or chronic ITP</h2>
                <p>
                  If you’re looking to meet others with children living with
                  platelet conditions like persistent or chronic immune
                  thrombocytopenia, these organizations are good places to
                  start. They exist to create a community of support and
                  information for people living with ITP.
                </p>
              </div>
              <div>
                <img src="/images/ped/resources/support-group@2x.png" alt="" />
              </div>
            </div>
            <div className="support-group-cards">
              <div className="support-group-card">
                <img
                  src="/images/ped/resources/platelet-disorder-support-assocation-pdsa-logo-empowering-itp-patients@2x.png"
                  alt=""
                  style={{ maxWidth: "135px" }}
                />
                <h3>Platelet Disorder Support Association (PDSA)</h3>
                <p>
                  A non-profit organization founded in 1998 to enhance the lives
                  of patients and caregivers living with ITP or other platelet
                  disorders through education, advocacy, research, and support.
                </p>
                <a
                  href="https://pdsa.org/"
                  className="btn btn-primary btn-white btn-external-link w-100"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>visit pdsa</span>
                </a>
              </div>
              <div className="support-group-card">
                <img
                  src="/images/ped/resources/foundation-for-women-and-girls-blood-disorders-logo@2x.png"
                  alt=""
                  style={{ maxWidth: "222px" }}
                />
                <h3>
                  Foundation for Women &amp; Girls with Blood Disorders (FWGBD)
                </h3>
                <p>
                  An organization that helps to ensure that all women with blood
                  disorders are correctly diagnosed and treated at every stage
                  of life.
                </p>
                <a
                  href="https://www.fwgbd.org/resources/patient-resources"
                  className="btn btn-primary btn-white btn-external-link w-100"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>visit FWGBD</span>
                </a>
              </div>
              <div className="support-group-card">
                <img
                  src="/images/ped/resources/national-organization-for-rare-disorders-nord-logo@2x.png"
                  alt=""
                  style={{ maxWidth: "208px" }}
                />
                <h3>National Organization for Rare Disorders (NORD)</h3>
                <p>
                  A non-profit organization for people living with rare
                  diseases. NORD is committed to the identification, treatment,
                  and cure of rare diseases.
                </p>
                <a
                  href="https://rarediseases.org/rare-diseases/immune-thrombocytopenia/"
                  className="btn btn-primary btn-white btn-external-link w-100"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span>visit NORD</span>
                </a>
              </div>
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding ped-faq">
          <h2>Frequently asked questions</h2>
          <Accordion
            title="Is ITP hereditary?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  People with ITP don’t normally have a family history of
                  thrombocytopenia (or low platelet counts), but if your child
                  does, you should let your doctor know so a possible genetic
                  link can be considered.
                </p>
              </>
            }
          />
          <Accordion
            title="Is ITP cancer?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  No, ITP is a blood disorder and an autoimmune condition in
                  which your child’s immune system attacks the platelets in
                  their body.
                </p>
              </>
            }
          />
          <Accordion
            title="Is ITP a type of hemophilia?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  While both hemophilia and ITP are bleeding disorders, ITP is
                  not a form of hemophilia. Hemophilia is an inherited
                  condition, while ITP is an autoimmune disorder. Both
                  conditions are similar in that they affect the body’s ability
                  to clot.
                </p>
              </>
            }
          />
          <Accordion
            title="Is ITP an autoimmune condition?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  Yes, ITP is an autoimmune condition. When your child has
                  immune thrombocytopenia, their immune system attacks the
                  platelets in their body, leaving your child’s platelet count
                  low.
                </p>
              </>
            }
          />
          <Accordion
            title="Who treats pediatric ITP?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  Typically, ITP is treated by pediatric hematologists, who
                  specialize in treating blood disorders. ITP may also be
                  treated by pediatric oncologists who specialize in hematology.
                  These hematologist oncologists, or “Hem Oncs,” treat children
                  with blood disorders like ITP and people with cancers
                  associated with blood.
                </p>
              </>
            }
          />
          <Accordion
            title="Can ITP be cured?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  In children, ITP is often a newly diagnosed—or acute—condition
                  and can go away on its own. However, ITP can also turn into a
                  persistent or chronic disorder that is lifelong once
                  diagnosed. With a care team and treatment plan, your child’s
                  ITP can be managed to reduce signs and symptoms.
                </p>
              </>
            }
          />
          <Accordion
            title="What is the difference between persistent and chronic ITP?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  ITP is categorized based on the length of time with the
                  condition. Newly diagnosed—sometimes also called “acute”—is
                  from the time of diagnosis to 3 months, persistent is from
                  3-12 months, and chronic is having ITP for longer than a year.
                </p>
                <p>
                  Newly diagnosed/acute ITP is found more commonly in children.
                  About 70% of childhood ITP cases resolve on their own, usually
                  within 6 months, but a small percentage can progress to a
                  persistent or chronic condition.
                </p>
                <p>
                  Doptelet and Doptelet Sprinkle are not used to treat acute
                  ITP.
                </p>
              </>
            }
          />
          <Accordion
            title="What types of treatment are available for ITP in children?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  There are a few different types of treatment for ITP that all
                  aim to raise platelet counts to a level that helps lower the
                  risk of bleeding. The most common are corticosteroids,
                  immunosuppressants, thrombopoietin receptor agonists
                  (TPO-RAs), and splenectomies. This is not a complete list of
                  treatments. Talk to your child’s doctor to understand all of
                  your options and see what might work for them.
                </p>
                <p>
                  <a href="/pediatric-itp/what-is-itp-in-children/#treatment">
                    You can also learn more about these treatments here
                  </a>
                  .
                </p>
              </>
            }
          />
          <Accordion
            title="What are the side effects of Doptelet and Doptelet Sprinkle?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  With Doptelet or Doptelet Sprinkle, your child may experience
                  side effects.
                </p>
                <p style={{ marginBottom: "4px" }}>
                  <strong>Serious side effects</strong>
                </p>
                <p style={{ marginBottom: "4px" }}>
                  Doptelet or Doptelet Sprinkle may cause serious side effects including blood clots. People with persistent or chronic ITP and people with certain blood clotting conditions may have an increased risk of developing blood clots. Tell your healthcare provider right away if you get signs and symptoms of a blood clot, including:
                </p>
                <ul>
                  <li>Swelling, pain, or tenderness in their legs</li>
                  <li>Shortness of breath</li>
                  <li>Chest pain</li>
                  <li>Fast heartbeat</li>
                  <li>Stomach (abdominal) pain or tenderness</li>
                </ul>
                <p style={{ marginBottom: "4px" }}>
                  <strong>Common side effects</strong>
                </p>
                <p>
                  The most common side effects of Doptelet or Doptelet Sprinkle in children with persistent or chronic ITP are viral infection, runny nose, cough, fever, and pain in the mouth or throat.
                </p>
                <p>
                  <strong>
                    These are not all the possible side effects of Doptelet and
                    Doptelet Sprinkle. Talk to your child’s doctor if any side
                    effect bothers your child or does not go away.
                  </strong>
                </p>
              </>
            }
          />
          <Accordion
            title="Are there any food restrictions while taking Doptelet or Doptelet Sprinkle?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  What food your child eats, and when, does not impact the
                  effectiveness of their treatment with Doptelet or Doptelet
                  Sprinkle. Food is required when taking Doptelet in tablet
                  form, and soft food or liquid is required when taking Doptelet
                  Sprinkle.
                </p>
                <p>
                  <strong>
                    Recommended soft foods to take with Doptelet Sprinkle:
                  </strong>{" "}
                  applesauce, strawberry jelly, or yogurt (plain)
                </p>
                <p>
                  <strong>
                    Recommended liquids to take with Doptelet Sprinkle:
                  </strong>{" "}
                  milk (whole or skim), orange juice, pediatric electrolyte
                  solution (unflavored), or water
                </p>
                <p>
                  Remember, your child should take treatment as directed by
                  their doctor. Before starting Doptelet or Doptelet Sprinkle,
                  tell your child’s doctor about all the medicines they take, as
                  their doctor may adjust the starting dose.
                </p>
              </>
            }
          />
          <Accordion
            title="What is the difference between Doptelet and Doptelet Sprinkle?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  Both Doptelet and Doptelet Sprinkle are TPO-RAs. Doptelet
                  tablet is indicated for patients 6 and older and should be
                  taken whole, with any food. Doptelet Sprinkle oral granules are indicated for
                  patients 1 year to less than 6 years and must be mixed into a
                  soft food or liquid.
                </p>
                <p>
                  <strong>
                    Recommended soft foods to take with Doptelet Sprinkle:
                  </strong>{" "}
                  applesauce, strawberry jelly, or yogurt (plain)
                </p>
                <p>
                  <strong>
                    Recommended liquids to take with Doptelet Sprinkle:
                  </strong>{" "}
                  milk (whole or skim), orange juice, pediatric electrolyte
                  solution (unflavored), or water
                </p>
                <p>Doptelet tablets that come in a blister package are not the same dosage form as Doptelet Sprinkle that come in a bottle and cannot be directly substituted for each other.</p>
              </>
            }
          />
          <Accordion
            title="What if my child misses a dose of Doptelet or Doptelet Sprinkle?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <p>
                  If your child misses their dose of Doptelet or Doptelet
                  Sprinkle, they should take it as soon as they remember. They
                  should not take 2 doses at once to make up for missing a dose.
                  Your child should take their next dose at their usual time.
                </p>
              </>
            }
          />
          <Accordion
            title="What if my child takes too much Doptelet or Doptelet Sprinkle?"
            id="more-results"
            className="scroll-to-section mb-0"
            markup={
              <>
                <p>
                  If your child takes too much Doptelet or Doptelet Sprinkle,
                  call your healthcare provider or Poison Help Line at{" "}
                  <a href="tel: +8002221222">1-800-222-1222</a>, or go to the
                  nearest hospital emergency room right away.
                </p>
              </>
            }
          />
        </Section>

        {/* <Section>
          <div className="looking-for-resources-patient">
            <div className="d-flex flex-column flex-lg-row">
              <div className="looking-for-resources-content">
                <h3>Find a persistent and chronic ITP specialist near you</h3>
                <p>
                  One of the most important steps to getting the care your child
                  deserves is finding the right hematologist in your area.
                </p>
                <p>
                  <small>
                    Sobi is not responsible for the choices or actions that you
                    or others take because of information provided by this free
                    tool.
                  </small>
                </p>
              </div>
              <div className="looking-for-resources-link">
                <a
                  href="/ped/resources/patient-resources/"
                  className="btn btn-primary btn-arrow"
                  onClick={showPhreesiaModal}
                >
                  <span>Find a specialist</span>
                </a>
              </div>
            </div>
          </div>
        </Section> */}
        <Section sectionClass="section-padding">
          <div className="presistent-cta">
            <div>
              <img src="/images/ped/icons/icon-soft-serve@2x.png" alt="" />
            </div>
            <div>
              <h2>Find a persistent or chronic ITP specialist near you</h2>
              <p>
                One of the most important steps to getting the care your child
                deserves is finding the right provider in your area.
              </p>
              <a
                href="#"
                className="btn btn-primary"
                onClick={showPhreesiaModal}
              >
                Find a specialist
              </a>
              <p>
                Sobi is not responsible for the choices or actions that you or
                others take because of information provided by this free tool.
              </p>
            </div>
          </div>
        </Section>
      </PEDLayout>
    </>
  );
}
